import { render, staticRenderFns } from "./PerPriceHorizontalBarChart.vue?vue&type=template&id=6eda0d60&lang=pug&"
import script from "./PerPriceHorizontalBarChart.vue?vue&type=script&lang=ts&"
export * from "./PerPriceHorizontalBarChart.vue?vue&type=script&lang=ts&"
import style0 from "./PerPriceHorizontalBarChart.vue?vue&type=style&index=0&id=6eda0d60&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports